module.exports = __webpack_public_path__ + "img/e1@2x.5c2a4b13.png";